const ns = 'BZ-Agenda';

export const apiClasses = {
    daySelect: `${ns}-DaySelect`,
    dayOption: `${ns}-DaySelect-Option`,
    dayOptionSelected: `${ns}-DaySelect-Option--selected`,
};
export const dataTestIds = {
    daySelect: `${ns}-DaySelect`,
    dayOption: `${ns}-DaySelect-Option`,
};
